/**
 * Copyright © 2018 Emu Analytics
 */

import { IMapLayer } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';
import { WebSocketSubscribeCallback, WebSocketUnsubscriber } from './web-socket-gateway';

export class MapLayerEndpoints extends BaseEndpoints<IMapLayer> {
  constructor(client: Client) {
    super(client, 'maplayers');
  }

  subscribe(cb: WebSocketSubscribeCallback): WebSocketUnsubscriber {
    return this.client._subscribe(`maplayers`, cb);
  }
}
